//cjs
const name = 'g-form'

export default{
    name,
    props:{
       
    },

    created(){

    },

    mounted(){

    },

    data(){
        return{}
    },

    methods : {

    },

}
